import React from "react";

import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faInfoCircle } from "@fortawesome/pro-solid-svg-icons/faInfoCircle";
import { FontAwesomeIcon, FontAwesomeIconProps } from "@fortawesome/react-fontawesome";
import Tooltip, { TooltipProps } from "antd/es/tooltip";
import cn from "classnames";

import styles from "./TextWithInfo.module.scss";

interface Props {
  children?: React.ReactNode;
  className?: string;
  icon?: IconProp;
  iconProps?: Omit<FontAwesomeIconProps, "icon">;
  info?: React.ReactNode;
  inline?: boolean;
  placeIconOnLeftSide?: boolean;
  placement?: TooltipProps["placement"];
  tooltipOverlayClassName?: string;
  trigger?: TooltipProps["trigger"];
}

const TextWithInfo = ({
  children,
  className,
  icon,
  iconProps,
  info,
  inline,
  placeIconOnLeftSide,
  placement = "rightTop",
  tooltipOverlayClassName,
  trigger,
}: Props) => {
  const { className: iconClassName, ...otherIconProps } = iconProps ?? {};
  return (
    <div className={cn(styles.container, className, { [styles.inline]: inline })}>
      {children && !placeIconOnLeftSide && <span className={styles.text}>{children}</span>}
      {info && (
        <Tooltip
          overlayClassName={tooltipOverlayClassName}
          placement={placement}
          title={info}
          trigger={trigger}
        >
          <FontAwesomeIcon
            className={cn(styles.icon, iconClassName, { [styles.sized]: !iconProps?.size })}
            icon={icon ?? faInfoCircle}
            {...otherIconProps}
          />
        </Tooltip>
      )}
      {children && placeIconOnLeftSide && <span className={styles.text}>{children}</span>}
    </div>
  );
};

export default TextWithInfo;
